import { Fragment } from 'react';
import Filter from '../Commons/Filter';
import Table from '../Commons/Table';
import { dateFormatter } from '../../lib/formatter';
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';
import { BlackListProps } from '../../types/blackList';

/* styled */
const ContentTitle = styled.div`
  position: absolute;
  top: -3.1875rem;
  right: 0;
  height: 2rem;

  @media screen and (max-width: 768px) {
    top: -2.5625rem;
  }
  @media screen and (max-width: 480px) {
    position: relative;
    top: 0;
    height: auto;
    margin-left: -1rem;
    padding: 0.625rem 1rem;
    width: 100%;
    background: #ffffff;
    border-top: 1px solid #cccccc;
  }
`;
const ContentTopButtonForm = styled.div`
  float: right;
  margin: 1.25rem auto;

  .center {
    display: block;
    padding-top: 0;

    .detail {
      right: 0;
    }
    .pl20 {
      padding-left: 1.25rem;
    }
  }
`;
const ContentButton = styled.button`
  height: 2.3rem;
  min-width: 5rem;
  padding: 0.5rem;
  border-radius: .35rem;
  color: #ffffff;
  font-size: 0.875rem;
  font-weight: bold;
  background-color: #044dac;
  border: 0px;
  cursor: pointer;
  box-shadow: 0 0 1px 0 rgb(0 0 0 / 20%), 
  0 2px 4px -2px rgb(0 0 0 / 30%);

  :hover {
    background-color: #4c9ffe;
  }
  :disabled {
    background-color: #949494;
    cursor: default;
  }
`;

const BlackList = ({
    blackListItems,
    filterItem,
    userRole,
    blackListTotal,
    handleFilter,
    handleinitFilter,
    handleBlackListDetail,
    handleBlackListCreateModal,
    handleBlackListUpdateModal,
    handleBlackListDeleteModal,
}:BlackListProps) => {

  return (
    <Fragment>
      <ContentTitle>
        <Filter
          columns={[
            {
              key: 'room_no',
              size: 'lg',
              placeholder: '객실이름',
              value: filterItem.room_no,
              action: handleFilter,
            },
          ]}
          init={handleinitFilter}
        />
      </ContentTitle>
      {userRole === 'master'? (
        <ContentTopButtonForm>
          <ContentButton onClick={handleBlackListCreateModal}>
            <FontAwesomeIcon icon={faPlusCircle} className='icon-item-add'/>
            <span>객실 추가</span>
          </ContentButton>
        </ContentTopButtonForm>
      ) : (<div style={{paddingTop: '1.25rem'}}></div>)
      }
      <Table
        columns={[
          {
            key: 'view',
            text: '상세보기',
            width: '8%',
            moveToPage: {
              func: handleBlackListDetail,
              params: ['id'],
            },
          },
          {
            key: 'hotel_name',
            text: '호텔명',
            width: '27%',
          },
          {
            key: 'room_no',
            text: '객실명',
            width: '20%',
          },
          {
            key: 'room_type_code',
            text: '객실타입',
            width: '20%',
          },
          {
            key: 'created_at',
            text: '생성일자',
            width: '25%',
            formatter: {
              func: dateFormatter,
              params: ['created_at'],
            },
          },
          {
            key: 'button',
            text: '',
            width: '5%',
            items: [
              {
                text: '객실 수정',
                action: {
                  func: (id:string) => handleBlackListUpdateModal(id),
                  params: ['id'],
                },
              },
              {
                text: '객실 삭제',
                action: {
                  func: (id:string, room_no: string) => handleBlackListDeleteModal(id, room_no),
                  params: ['id', 'room_no'],
                },
              },
            ],
          },
        ]}
        datas={blackListItems}
        userRole={userRole}
        total={blackListTotal}
      />
    </Fragment>
  );
};

export default BlackList;